export default __webpack_public_path__ + "static/media/AboutUsImage.d798ce75.png";